import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import dayjs from 'dayjs';
import { ACADEMIC_REFEREE } from './ACADEMIC_REFEREE.gql';
import type {
  AcademicRefValue,
  GetAcademicReferee,
  GetAcademicRefStatus,
  AcademicRefStatus,
} from './types';
import { checkInvalidDate } from '../checkInvalidDate';

const NA = 'N/A';
export const useGetAcademicReferee = (id: string): GetAcademicReferee => {
  const { data, loading, error } = useQuery(ACADEMIC_REFEREE, {
    variables: { id },
    skip: !id,
    fetchPolicy: 'network-only',
  });

  const {
    title,
    name,
    institution,
    position,
    relationship,
    email,
    phoneNumber,
    faxNumber,
  } = data?.academicReferee ?? {};

  const academicRefValue: AcademicRefValue = {
    title,
    name,
    institution,
    position,
    relationship,
    email,
    phoneNumber,
    faxNumber,
  };
  return { academicRefValue, loading, error };
};

export const useGetAcademicRefereeStatus = (
  applicationId: string,
  isGSMember: boolean,
): GetAcademicRefStatus => {
  const { data, loading, error, refetch } = useQuery(
    gql`
      query ($applicationId: ID!) {
        queryRefereeForm(applicationId: $applicationId) {
          refereeReportStatus {
            academicRefereeId
            status
            deadline
            repliedAt
            lastSentDate
          }
        }
      }
    `,
    {
      variables: { applicationId },
      skip: !applicationId || !isGSMember,
      fetchPolicy: 'network-only',
    },
  );

  const academicRefStatus: AcademicRefStatus[] =
    data?.queryRefereeForm?.refereeReportStatus.map((refStatus: any) => ({
      academicRefereeId: refStatus.academicRefereeId,
      status: refStatus.status,
      lastSentDate: checkInvalidDate(refStatus.lastSentDate)
        ? NA
        : dayjs(refStatus.lastSentDate).format('DD/MM/YYYY HH:mm'),
      repliedAt: checkInvalidDate(refStatus.repliedAt)
        ? NA
        : dayjs(refStatus.repliedAt).format('DD/MM/YYYY HH:mm'),
      deadline: checkInvalidDate(refStatus.deadline)
        ? NA
        : dayjs(refStatus.deadline).format('DD/MM/YYYY HH:mm'),
    })) ?? [];

  return {
    academicRefStatus,
    loading,
    error,
    refetch,
  };
};
